
import React from 'react';
import { PixelCrop } from 'react-image-crop';

interface CropperPreviewProps {
  completedCrop: PixelCrop | undefined;
  imageSrc: string;
  imgRef: React.RefObject<HTMLImageElement>;
  canvasRef: React.RefObject<HTMLCanvasElement>;
  zoom: number;
}

const CropperPreview = ({ completedCrop, imageSrc, imgRef, canvasRef, zoom }: CropperPreviewProps) => {
  if (!completedCrop) return null;

  return (
    <div className="text-center">
      <p className="text-sm text-gray-600 mb-2 font-medium">Preview:</p>
      <div className="w-20 h-20 mx-auto rounded-lg overflow-hidden border-2 border-pink-300 bg-gray-100 shadow-md">
        <canvas
          ref={canvasRef}
          className="w-full h-full object-cover"
          style={{ display: 'none' }}
        />
        {completedCrop && imgRef.current && (
          <div 
            className="w-full h-full bg-cover bg-center"
            style={{
              backgroundImage: `url(${imageSrc})`,
              backgroundPosition: `${-completedCrop.x * (80 / completedCrop.width) / zoom}px ${-completedCrop.y * (80 / completedCrop.height) / zoom}px`,
              backgroundSize: `${imgRef.current.width * (80 / completedCrop.width) * zoom}px ${imgRef.current.height * (80 / completedCrop.height) * zoom}px`
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CropperPreview;
